module.exports = __webpack_public_path__ + "fonts/iconfont.bc03d47.woff2";